export const DRUG_CATEGORIES = {
  SUPPORTING: 'Supporting',
  TREATING: 'Treating',
};
